export default __webpack_public_path__ + "static/avatar-tag-2-do-dark-dabb592c97b9021e8e35738f6014fc84.png";